import Skeleton from "common/components/ui/Skeleton";
import { Tag } from "common/components/ui/Tag";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "common/components/ui/Tooltip";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

import type { JSX } from "react";

interface BaseLeadDetailTagProps {
  isLoading: boolean;
  children: string;
  extraItems: string[];
  leftComponent?: JSX.Element;
}

export default function BaseLeadDetailTag({
  isLoading,
  children,
  extraItems,
  leftComponent,
}: BaseLeadDetailTagProps) {
  const isDesktop = useTwBreakpoint("lg");

  if (isLoading) {
    return <Skeleton className="w-32 h-5 lg:h-4" />;
  }

  return (
    <div className="flex items-center gap-x-1">
      {isDesktop ? (
        <div className="flex flex-row items-center gap-x-1.5 max-w-40 overflow-hidden">
          {leftComponent}
          <span className="truncate text-xs-semibold">{children}</span>
        </div>
      ) : (
        <Tag size="sm" variant="tertiary" leftIcon={leftComponent}>
          {children}
        </Tag>
      )}

      {!!extraItems.length && (
        <Tooltip>
          <TooltipTrigger asChild>
            <Tag
              variant="tertiary"
              size={isDesktop ? "md" : "sm"}
              className="shrink-0"
            >
              + {extraItems.length}
            </Tag>
          </TooltipTrigger>

          <TooltipContent className="flex-col flex">
            {extraItems.slice(0, 25).map((item) => (
              <span key={item}>{item}</span>
            ))}
          </TooltipContent>
        </Tooltip>
      )}
    </div>
  );
}
